<div
	class="dashboard-card color-{{ color }}"
	[ngClass]="{ 'is-action-card': hasActionListener() }"
	(click)="action.emit()">
	@if (!loading) {
		<div class="dashboard-card__content">
			<div class="dashboard-card__value-wrap">
				<div class="dashboard-card__value">
					{{ value }}
					@if (hasActionListener()) {
						<i class="fa-regular fa-arrow-up-right"></i>
					}
				</div>
				<div class="dashboard-card__sub-value">
					{{ subValue }}
				</div>
			</div>
			<div class="dashboard-card__description">
				{{ description }}
			</div>
		</div>
	} @else {
		<div class="dashboard-card__loading">
			<div class="dashboard-card__loading-icon">
				<i class="fa-regular fa-loader fa-spin"></i>
			</div>
		</div>
	}

	<div class="dashboard-card__icon">
		<i [ngClass]="icon"></i>
	</div>
</div>
